import _ from 'lodash';
export default {
  methods: {
    mixData(elements) {
      let value = elements.items;
      if (elements.shuffle) {
        value = _.shuffle(elements.items);
      }
      if (elements.pick) {
        value = _.take(_.cloneDeep(value), elements.pick);
      }
      return value;
    },
    processData(node, staticText, imageArray, parentNode) {
      if (node.items) {
        // if(status.lengt>0){}
        if (node.pick && node.shuffle) {
          node.items = _.sampleSize(_.cloneDeep(node.items), node.pick);
        } else if (node.pick) {
          node.items = _.take(_.cloneDeep(node.items), node.pick);
        }
        if (node.shuffle) {
          node.items = _.shuffle(node.items);
        }
        if (node.staticText) {
          staticText.push(node.staticText);
        }
        if (node.imageData) {
          imageArray.push(node.imageData);
        }
        return _.flattenDeep(
          _.map(node.items, (item) => {
            return this.processData(item, staticText, imageArray, node);
          })
        );
      }
      // let status = _.filter(node.items, 'staticIndex');
      if (node.staticText) {
        staticText.push(node.staticText);
      }
      if (node.imageData) {
        imageArray.push(node.imageData);
      }
      return node;
    },
    mixAnswers(elements) {
      let value = elements.answers;
      if (elements.shuffle) {
        value = _.shuffle(elements.answers);
      }
      if (elements.pick) {
        value = _.take(_.cloneDeep(value), elements.pick);
      }
      return value;
    },
    selectGamePrepareData() {
      let data = _.cloneDeep(this.startGameConfig.items);
      this.imageData = [];
      /**
       *  first random selection if children has contians items arrray;
       * @method if
       */
      if (data && data[0] && _.isArray(data[0].items)) {
        if (data[0].imageData) {
          this.imageData.push(data[0].imageData);
        }
        if (this.startGameConfig.mainImage) {
          this.imageData.unshift(this.startGameConfig.mainImage);
        } else if (this.startGameConfig.background) {
          this.imageData = Object.assign({}, { imagePath: this.startGameConfig.background });
        }
        //  only 1 set can be choose (it's not possible to get two different set simultaneously);
        data = this.mixData(_.cloneDeep(this.startGameConfig))[0];
      }
      data = this.mixData(data);
      _.each(data, (item) => {
        if (item.imageData) {
          this.imageData.push(item.imageData);
        }
      });
      /**
       * mix answer
       * @type {[type]}
       */
      data = _.map(data, (item) => {
        if (item.answers) {
          item.answers = this.mixAnswers(item);
        }
        return item;
      });
      // data = this.mixData(this.startGameConfig.items);
      let text = _.cloneDeep(this.startGameConfig.staticText || []);
      if (_.isArray(this.imageData)) {
        this.imageData = _.map(this.imageData, (item, index) => {
          if (this.startGameConfig.layoutImage && this.startGameConfig.layoutImage[index]) {
            return Object.assign(item, this.startGameConfig.layoutImage[index]);
          } else {
            return item;
          }
        });
      }
      this.textList = _.map(text, (item, index) => {
        return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
      });
      this.dataItems = _.map(data, (item, index) => {
        return Object.assign(item, this.startGameConfig.layoutItems[index]);
      });
      return data;
    },
    checkboxGamePrepareData() {
      let data = _.cloneDeep(this.startGameConfig.items);
      /**
       *  first random selection if children has contians items arrray;
       * @method if
       */
      if (data && data[0] && _.isArray(data[0].items)) {
        //  only 1 set can be choose (it's not possible to get two different set simultaneously);
        data = this.mixData(_.cloneDeep(this.startGameConfig))[0];
      }
      data = this.mixData(data);
      /**
       * mix answer
       * @type {[type]}
       */
      data = _.map(data, (item) => {
        if (item.items) {
          item.items = this.mixData(item);
        }
        return item;
      });
      // FIXME: if one element it's not working
      if (data.length === 1) {
        data = data[0].items;
      }
      // data = this.mixData(this.startGameConfig.items);
      let text = _.cloneDeep(this.startGameConfig.staticText || []);

      this.textList = this.staticText = _.map(text, (item, index) => {
        return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
      });
      this.dataItems = _.map(data, (item, index) => {
        return Object.assign(item, this.startGameConfig.layoutItems[index]);
      });
      console.log('  this.dataItems', this.dataItems);
      return data;
    },
  },
};
